import io from 'socket.io-client';
import { tenantSocketAuth } from '../services/TenantService';
import { HIVE_URL } from '../runtimeConfig';

/** Socket instance returned by `io()` — avoids TS2749 when `Socket` is only a runtime export. */
type IoClientSocket = ReturnType<typeof io>;

/**
 * SocketsApi Implementation
 */
class SocketsApi {
    socket: IoClientSocket;

    /**
     * Constructs SocketsApi Instance
     */
    constructor() {
        this.socket = {} as IoClientSocket;
    }

    connect(payload: any) {

        return new Promise((resolve, reject) => {

            this.socket = io(`${HIVE_URL}/clients`, {
                query: { token: payload.token, ...tenantSocketAuth() },
                transports: ['websocket']
            });

            this.socket.on('connect', () => {
                console.log('Authenticated to sockets');
                resolve(this.socket)
            });

            this.socket.on('error', (error: any) => {
                console.log('Error connecting to server', error);
                reject(this.socket)
            });

            this.socket.on('disconnect', () => {
                console.log('Disconnect from server');
            });
        
            this.socket.on('reconnect', () => {
                console.log('Reconnected to server');
            });
        
            this.socket.on('reconnect_attempt', () => {
                console.log('Reconnect Attempt');
            });
        
            this.socket.on('reconnecting', () => {
                console.log('Reconnecting to server');
            });
        
            this.socket.on('reconnect_error', () => {
                console.log('Reconnect Error');
            });
        
            this.socket.on('reconnect_failed', () => {
                console.log('Reconnect failed');
            });
        
            this.socket.on('connect_error', () => {
                console.log('connect_error');
            });
        })
    }
}

export default new SocketsApi()